import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=658c6b3e&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('658c6b3e')) {
      api.createRecord('658c6b3e', component.options)
    } else {
      api.reload('658c6b3e', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=658c6b3e&", function () {
      api.rerender('658c6b3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-484pp4dbPaoN5/JS/videoIframe.vue"
export default component.exports